import React from 'react';
import { Grid } from '@mui/material';
import useStore from '../../store/useStore';
import StatementCardSessions from './StatementCardSessions';
import LinearProgress from '@mui/material/LinearProgress';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';



function renderStyleifPublished() {
  const tags = document.getElementsByClassName('ituMainNav'); //search class in itu wordpress theme

  if (tags.length > 0) {
    // contains.
    return 'ituContainer grid fullWidthCards'; //class for wordpress
  } else return 'ituContainer grid fullWidthCards'; //class in standalone react
}

const loadingBgColor = '#DFF2F8'





const CardViewSessions = () => {
  const { cards } = useStore((state: any) => ({ cards: state.MUIdataSessions.rows }));
  const 
  { 
    datasource,
    loading
  } = useStore((state: any) => 
  (
    { 
      datasource: state.settings.params.datasource,
      
      loading: state.loading,
    }));

  // Get pagination information from state
  const { currentSessionPage, sessionsPerPage, changeCurrentSessionPage } = useStore((state: any) => ({
    currentSessionPage: state.currentSessionPage,
    sessionsPerPage: state.sessionsPerPage,
    changeCurrentSessionPage: state.changeCurrentSessionPage,
  }));

  //calculate pagination slice interval
  const indexOfLastPost = currentSessionPage * sessionsPerPage;
  const indexOfFirstPost = indexOfLastPost - sessionsPerPage;

  //slice cards to get paginated posts
  const paginatedCards = cards.slice(indexOfFirstPost, indexOfLastPost);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    changeCurrentSessionPage(value)
    //scroll to top
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Grid container style={{ width: '100%', margin: '2rem auto 0' }} >
      <Grid item xs={12}>
        <div className={renderStyleifPublished()}>
          {cards.length > 0 ? (
            paginatedCards.map((card: any, i: any) => {
              return <StatementCardSessions key={i} data={card} datasource={datasource} />;
            })
          ) : (
            <div className={renderStyleifPublished()} data-span="12"  >

            {loading ? (
              <>
              <Box data-span="4" sx={{ width: 390, height: 320, marginRight: 0.5, my: 5 }}>

                <Skeleton
                  animation="pulse"
                  sx={{ bgcolor: loadingBgColor }}
                  variant="rectangular"
                  width={390}
                  height={320}
                />
                <Box sx={{ width: 390, pt: 0.5 }}>
                  <Skeleton sx={{ bgcolor: loadingBgColor }} />
                  <Skeleton sx={{ bgcolor: loadingBgColor }} width="60%" />
                </Box>

              </Box>

              <Box data-span="4" sx={{ width: 390, height: 320, marginRight: 0.5, my: 5 }}>

                <Skeleton
                  animation="pulse"
                  sx={{ bgcolor: loadingBgColor }}
                  variant="rectangular"
                  width={390}
                  height={320}
                />
                <Box sx={{ width: 390, pt: 0.5 }}>
                  <Skeleton sx={{ bgcolor: loadingBgColor }} />
                  <Skeleton sx={{ bgcolor: loadingBgColor }} width="60%" />
                </Box>

              </Box>


              <Box data-span="4" sx={{ width: 390, height: 320, marginRight: 0.5, my: 5 }}>

                <Skeleton
                  animation="pulse"
                  sx={{ bgcolor: loadingBgColor }}
                  variant="rectangular"
                  width={390}
                  height={320}
                />
                <Box sx={{ width: 390, pt: 0.5 }}>
                  <Skeleton sx={{ bgcolor: loadingBgColor }} />
                  <Skeleton sx={{ bgcolor: loadingBgColor }} width="60%" />
                </Box>

              </Box>
              </>

          ):(<>
          
          <Box data-span="12" sx={{textAlign:'center'}}>


<b>No records found</b>

</Box>
</>)

            }


            </div>
          )}




        </div>

      </Grid>


      {cards.length > sessionsPerPage ? (

        <Grid item xs={12}>
          <Stack spacing={2}>
            <Pagination count={Math.ceil(cards.length / sessionsPerPage)} page={currentSessionPage} onChange={handlePageChange} style={{
              justifyContent: "center",
              display: 'flex',
              marginTop: "1rem"
            }} />
          </Stack>
        </Grid>
      ) : null
      }

    </Grid >


  );
};

export default CardViewSessions;
